import {AnyFunc} from 'data/types'
import {useState, useEffect, useRef} from 'react'

export function useFunction<T extends AnyFunc>(action: T): T & {isRunning: boolean} {
  const [state, setState] = useState(false)
  const isMounted = useRef<boolean>(true)
  const setRunning = (value: boolean) => {
    if (isMounted.current) {
      setState(value)
    }
  }

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [isMounted])

  const fn = (...params: Parameters<T>) => {
    setRunning(true)
    const result = action(...params)
    if (result instanceof Promise) {
      return result.finally(() => {
        setRunning(false)
      })
    } else {
      setRunning(false)
    }
    return result
  }
  fn.isRunning = state
  // @ts-ignore
  return fn
}
